module.exports = __webpack_public_path__ + "img/SKLB-Centro de actividades.b2de9445.png";